module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "BerryMerry CharOverride-7"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('a', {
    attrs: {
      "href": "#/07ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('a', {
    attrs: {
      "href": "#/08atn"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Saturday Hockey")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Barn")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Summer Interrupted")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: What Does This Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Battle Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Induction")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: New Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Cancer Routine")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Days with Dinky")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: A Turn for the Worse")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Dark Times")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Boy Is Back")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Brett and the Bullies")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Partners in Mischief")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Getting Stronger")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Animals in the Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Survivor")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Hockey Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Olivia and the Penguins")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Dinky Donkey Doo")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "ToC"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74c8781a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06-toc.vue
// module id = 72
// module chunks = 0